import { FONT, ROOMS } from "@/lib/yuoDesign";
import StoneOrb from "@/components/yuo/StoneOrb";
import "./mobile.css";

export const MFONT = FONT;

// ⋯ — 40×40 circle, three 4px dots
export function MoreButton({ onClick, testId = "m-more" }) {
  return (
    <button type="button" data-testid={testId} aria-label="More" onClick={onClick} className="m-more"
      style={{
        width: 40, height: 40, borderRadius: "50%", border: "none", padding: 0, flex: "0 0 auto",
        background: "var(--m-more-bg)", display: "flex", alignItems: "center", justifyContent: "center", gap: 4,
        cursor: "pointer", boxShadow: "none",
      }}>
      {[0, 1, 2].map((i) => <span key={i} style={{ width: 4, height: 4, borderRadius: "50%", background: "var(--yuo-ink)" }} />)}
    </button>
  );
}

// Room header: stone 12px + name (+ sub) · right: ≤2 working buttons + ⋯
export function MobileHeader({ room = "mirror", title, sub, actions, onMore, left, testId = "m-header" }) {
  return (
    <div data-testid={testId} style={{
      position: "relative", flex: "0 0 auto", display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "6px 18px 10px", gap: 10, fontFamily: MFONT,
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
        {left || (
          <>
            <StoneOrb color={room} size={12} />
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 13, letterSpacing: "0.3em", textTransform: "uppercase", color: "var(--yuo-ink)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{title}</div>
              {sub && <div style={{ fontSize: 9, letterSpacing: "0.2em", textTransform: "uppercase", color: "var(--m-row-hint)", marginTop: 2, whiteSpace: "nowrap" }}>{sub}</div>}
            </div>
          </>
        )}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flex: "0 0 auto", justifyContent: "flex-end" }}>
        {actions}
        {onMore && <MoreButton onClick={onMore} />}
      </div>
    </div>
  );
}

// 38px header capsule button (room-coloured when `solid`)
export function MobileHeaderButton({ children, onClick, room = "mirror", solid = false, disabled, testId, ariaLabel }) {
  const meta = ROOMS[room] || ROOMS.mirror;
  return (
    <button type="button" data-testid={testId} aria-label={ariaLabel} onClick={onClick} disabled={disabled}
      style={{
        height: 38, padding: "0 14px", borderRadius: 999, border: "none", cursor: "pointer", fontFamily: MFONT,
        fontSize: 9.5, letterSpacing: "0.2em", textTransform: "uppercase", whiteSpace: "nowrap",
        background: solid ? `radial-gradient(120% 160% at 30% 0%, rgba(${meta.rgb},0.34), rgba(${meta.rgb},0.10))` : "var(--m-more-bg)",
        color: solid ? meta.text : "var(--yuo-ink)",
        boxShadow: solid ? `0 0 16px rgba(${meta.rgb},0.3)` : "none",
        opacity: disabled ? 0.5 : 1, outline: "none", WebkitTapHighlightColor: "transparent", animation: "none",
      }}>
      {children}
    </button>
  );
}

// 40×40 round stone button (ASK YUO / send) — stone gradient never changes with theme
export function StoneButton({ room = "mirror", size = 40, onClick, disabled, testId, ariaLabel, glow = true, className }) {
  const meta = ROOMS[room] || ROOMS.mirror;
  return (
    <button type="button" data-testid={testId} aria-label={ariaLabel} onClick={onClick} disabled={disabled} className={className}
      style={{
        width: size, height: size, borderRadius: "50%", border: "none", padding: 0, flex: "0 0 auto", cursor: disabled ? "default" : "pointer",
        background: `radial-gradient(38% 34% at 32% 26%, #fff 0%, ${meta.hex} 22%, rgba(${meta.rgb},0.45) 62%, #05060c 100%)`,
        boxShadow: glow ? `0 0 16px rgba(${meta.rgb},0.55)` : "none",
        opacity: disabled ? 0.55 : 1,
      }} />
  );
}
